export default {
  title: "Crédits",
  plans: {
    menuTitle: "Forfaits",
    title: "Forfaits d'abonnement",
    subtitle:
      "Le catalogue des forfaits. Les forfaits système (définis par le code) sont en lecture seule sauf l'activation ; ajoutez des forfaits personnalisés ci-dessous.",
    newPlan: "Nouveau forfait",
    newTitle: "Nouveau forfait",
    editTitle: "Modifier le forfait",
    empty: "Aucun forfait.",
    plan: "Forfait",
    product: "Produit",
    key: "Clé",
    displayName: "Nom",
    tier: "Niveau",
    price: "Prix",
    priceCents: "Prix (centimes)",
    currency: "Devise",
    entitlements: "Quotas",
    entitlementsHint: "Clé → limite. -1 pour illimité. Ex. lms.max_courses → 50.",
    addEntitlement: "Ajouter un quota",
    isDefault: "Forfait par défaut",
    isActive: "Actif",
    default: "Défaut",
    system: "Système",
    save: "Enregistrer",
    saved: "Forfait enregistré",
    cancel: "Annuler",
  },
  caption: "Gérer les soldes de crédits et les compteurs",
  balances: {
    title: "Soldes de crédits",
    home: { title: "Soldes" },
    set: "Définir le solde",
    new: "Octroyer des crédits",
    fields: {
      meter: "Compteur",
      subject: "Sujet",
      user: "Utilisateur",
      tenant: "Tenant",
      balance: "Solde",
      unlimited: "Illimité",
      userId: "ID utilisateur",
    },
    placeholder: {
      noBalances: "Aucun portefeuille — définissez un solde pour commencer.",
    },
    actions: {
      save: "Enregistrer",
      cancel: "Annuler",
    },
  },
  transactions: {
    title: "Transactions de crédits",
    fields: {
      meter: "Compteur",
      subject: "Sujet",
      user: "Utilisateur",
      delta: "Delta",
      balanceAfter: "Solde après",
      reason: "Raison",
      ref: "Référence",
      createdAt: "Quand",
      actor: "Acteur",
    },
    placeholder: {
      empty: "Aucune transaction.",
    },
  },
  meters: {
    title: "Compteurs",
    fields: {
      key: "Clé",
      displayName: "Nom",
      description: "Description",
    },
  },
  badge: {
    label: "Crédits",
    unlimited: "∞",
    none: "0",
  },
  errors: {
    insufficient: {
      title: "Crédits insuffisants",
      description:
        "Vous n'avez plus de crédits pour {meter}. Demandez à un administrateur d'en ajouter.",
    },
    planLimit: {
      title: "Limite du forfait atteinte",
      description:
        "Vous avez atteint la limite de votre forfait. Passez à un forfait supérieur ou contactez un administrateur.",
    },
  },
  upgrade: {
    title: "Améliorer votre forfait",
    subtitle: "Vous avez atteint la limite du forfait {plan}.",
    switchTo: "Passer à {plan}",
    switched: "Forfait changé pour {plan}",
    pay: "Passer à {plan}",
    checkoutStarted: "Redirection vers le paiement…",
    notNow: "Plus tard",
    close: "Fermer",
    maxedOut:
      "Vous êtes sur le forfait le plus élevé. Contactez-nous si besoin de plus.",
  },
  subscriptionReturn: {
    successTitle: "Forfait amélioré 🎉",
    successBody:
      "Votre nouveau forfait est actif. Les limites supérieures s'appliquent immédiatement.",
    backToStudio: "Retour au studio",
  },
  buy: {
    menuTitle: "Acheter des crédits",
    title: "Acheter des crédits",
    subtitle:
      "Choisissez un pack — vous serez redirigé vers notre prestataire de paiement.",
    creditsLabel: "crédits",
    buyButton: "Acheter",
    noPacks: "Aucun pack disponible pour le moment.",
  },
  return: {
    confirming: "Confirmation du paiement…",
    slowTitle: "Paiement bien reçu",
    slowBody:
      "Le traitement prend un peu plus de temps que d'habitude. Vous pouvez fermer cette page — un e-mail vous sera envoyé dès que les crédits seront crédités.",
    backToCredits: "Retour aux crédits",
    successTitle: "Crédits ajoutés",
    viewHistory: "Voir l'historique",
    failureTitle: "Le paiement n'a pas abouti",
    tryAgain: "Réessayer",
    missingIdTitle: "Référence de transaction manquante",
  },
  myTopups: {
    menuTitle: "Mes achats",
    title: "Mes achats de crédits",
    buyMore: "Acheter plus",
    empty: "Aucun achat pour le moment.",
  },
  adminTopups: {
    menuTitle: "Achats",
    title: "Tous les achats",
    userFilter: "ID utilisateur",
    statusFilter: "Statut",
    statusAll: "Tous",
    empty: "Aucun achat dans ce tenant.",
  },
  topups: {
    fields: {
      createdAt: "Date",
      pack: "Pack",
      user: "Utilisateur",
      amount: "Montant",
      credits: "Crédits",
      status: "Statut",
      actions: "Actions",
    },
  },
  refund: {
    title: "Rembourser",
    description:
      "Achat initial : {amount}. Le remboursement retirera le nombre de crédits correspondant.",
    amountLabel: "Montant",
    amountPlaceholder: "Vide pour remboursement total",
    amountHelp:
      "Montant dans la devise initiale. Laisser vide pour rembourser le solde restant.",
    reasonLabel: "Raison (facultatif)",
    reasonPlaceholder: "Ex. demande client, double facturation",
    submitButton: "Effectuer le remboursement",
    cancel: "Annuler",
  },
};
